function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import { createComponent } from '@cloudflare/style-container';

var ValueComponent = function ValueComponent(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  var key = props.id + '-key';
  return React.createElement(
    'div',
    { className: className, key: key },
    React.createElement(ReactSelect.defaultProps.valueComponent, props)
  );
};

ValueComponent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  value: PropTypes.object.isRequired
};
ValueComponent.displayName = 'Value';

var Value = createComponent(function (_ref2) {
  var theme = _ref2.theme,
      onRemove = _ref2.onRemove,
      disabled = _ref2.disabled;

  // onRemove implies it's a multi-select value
  if (onRemove) return {
    backgroundColor: theme.colors.gray[9],
    border: '1px solid #a0a1a4',
    color: theme.colors.gray[3],
    display: 'inline-block',
    fontSize: '.86667rem',
    lineHeight: 1.4,
    marginLeft: '4px',
    marginTop: '4px',
    verticalAlign: 'top',
    '& .Select-value-icon': {
      cursor: disabled ? 'not-allowed' : 'pointer',
      padding: '3px 5px 1px 5px',
      display: 'inline-block',
      verticalAlign: 'middle',
      float: 'right'
    },
    '& .Select-value-icon:hover': {
      color: theme.colors.gray[3]
    },
    '& .Select-value-icon:focus': {
      backgroundColor: theme.colors.gray[7],
      color: theme.colors.gray[3]
    },
    '& .Select-value-icon:active': {
      backgroundColor: theme.colors.gray[7]
    },
    '& .Select-value-label': {
      cursor: 'default',
      padding: '2px 1px 2px 8px',
      position: 'relative',
      top: '2px'
    },
    '& .Select--multi a.Select-value-label': {
      color: theme.colors.blue[4],
      cursor: 'pointer',
      textDecoration: 'none'
    },
    '& .Select--multi a.Select-value-label:hover': {
      textDecoration: 'underline'
    }
  };

  return {
    bottom: 0,
    color: ' #333',
    left: 0,
    lineHeight: '32px',
    paddingLeft: '10px',
    paddingRight: '10px',
    position: 'absolute',
    right: 0,
    top: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
}, ValueComponent);

export default Value;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/Value.js
// module id = 1109
// module chunks = 1